import React from 'react';
import { SERVER_ERROR, HELP_INFO } from '../../constants/messages';
import Api from '../../api/api';
import LoginStore from '../../stores/login-store';
import Analytics from '../../services/analytics';
import { ModalHeader, ModalProgress, ModalStatusIcon, switchModal } from '../popups/modal-parts';

export default class VerifyToken extends React.Component {
  constructor() {
    super();
    this.state = {
      error: false,
      success: false,
      loading: true,
      error_heading: '',
      error_msg: '',
      alreadyVerified: false
    };
  }

  componentDidMount() {
    const { confirmation_token } = this.props.location.query;

    if (!confirmation_token) {
      this.setState({
        loading: false,
        error: true,
        error_msg: 'An invalid validation token has been provided',
        success: false
      });
      return;
    }

    LoginStore.verifyToken(confirmation_token, {
      onSuccess: () => {
        Analytics.event('email_verified');
        this.setState({
          loading: false,
          error: false,
          success: true
        });
      },
      onError: ({ error }) => {
        if (typeof(error) !== 'object') {
          return this.setState({
            loading: false,
            error: true,
            success: false
          });
        }

        const key    = Object.keys(error)[0];
        const title  = (key == 'email') ? 'Email already confirmed' : 'Confirmation token error';
        const reason = `The ${Api.snakeCaseToWords(key)} ${error[key][0]}.`;

        this.setState({
          loading: false,
          error: true,
          error_heading: title,
          error_msg: (error.email)? reason : `${reason} ${HELP_INFO}`,
          alreadyVerified: (error.email) ? true : false,
          success: false
        });
      }
    });
  }

  renderError() {
    const { error_heading, error_msg, alreadyVerified } = this.state;

    return (
      <div className="modal-body is-centered">
        <ModalStatusIcon type={alreadyVerified ? 'success' : 'error'} />
        <ModalHeader title={error_heading || SERVER_ERROR} />
        <div className="modal-text">
          <p>{error_msg || HELP_INFO}</p>
        </div>
        {alreadyVerified ? (
          <div className="modal-actions">
            <button type="button" className="modal-btn modal-btn-primary" onClick={() => switchModal('login')}>
              Sign in
            </button>
          </div>
        ) : null}
      </div>
    );
  }

  renderSuccess() {
    return (
      <div className="modal-body is-centered">
        <ModalStatusIcon type="success" />
        <ModalHeader title="Email verified" sub="Thanks for confirming your email address. Your account is ready to use." />
        <div className="modal-actions">
          <button type="button" className="modal-btn modal-btn-primary" onClick={() => switchModal('login')}>
            Sign in
          </button>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.error) {
      return this.renderError();
    }

    if (this.state.success) {
      return this.renderSuccess();
    }

    return (
      <div className="modal-body is-loading">
        <ModalProgress title="Verifying your email…" />
      </div>
    );
  }
}
